"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivedFilter = void 0;

var _styles = require("./styles");

var _removeFilter = _interopRequireDefault(require("../../../assets/images/activedFilter/removeFilter.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var ActivedFilter = function ActivedFilter(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _removeFilter.default,
        alt: "remove filter icon"
      })
    })]
  });
};

exports.ActivedFilter = ActivedFilter;